import { render, staticRenderFns } from "./ExtendOneToOneDialog.vue?vue&type=template&id=1afe7927&scoped=true"
import script from "./ExtendOneToOneDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExtendOneToOneDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ExtendOneToOneDialog.vue?vue&type=style&index=0&id=1afe7927&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afe7927",
  null
  
)

export default component.exports